// extracted by mini-css-extract-plugin
export default {"loadingFullscreen":"loadingFullscreen_loadingFullscreen__-Poec"};